var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_399_2185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2.22222C0 0.996528 0.996528 0 2.22222 0H7.77778V4.44444C7.77778 5.05903 8.27431 5.55556 8.88889 5.55556H13.3333V10H7.5C7.03819 10 6.66667 10.3715 6.66667 10.8333C6.66667 11.2951 7.03819 11.6667 7.5 11.6667H13.3333V15.5556C13.3333 16.7812 12.3368 17.7778 11.1111 17.7778H2.22222C0.996528 17.7778 0 16.7812 0 15.5556V2.22222ZM13.3333 11.6667V10H17.1563L15.8021 8.64583C15.4757 8.31944 15.4757 7.79167 15.8021 7.46875C16.1285 7.14583 16.6562 7.14236 16.9792 7.46875L19.7569 10.2465C20.0833 10.5729 20.0833 11.1007 19.7569 11.4236L16.9792 14.2014C16.6528 14.5278 16.125 14.5278 15.8021 14.2014C15.4792 13.875 15.4757 13.3472 15.8021 13.0243L17.1563 11.6701H13.3333V11.6667ZM13.3333 4.44444H8.88889V0L13.3333 4.44444Z",
    fill: "#43BBC9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_399_2185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 17.7778,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.dab38309d140d30a95e3464357b1b434.svg";
export { ForwardRef as ReactComponent };